import { render, staticRenderFns } from "./UserView_Followings.vue?vue&type=template&id=7a683a91&"
import script from "./UserView_Followings.vue?vue&type=script&lang=js&"
export * from "./UserView_Followings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports